// sleep code
var sleepInCartTray = (delay) =>
new Promise((resolve) => setTimeout(resolve, delay));

function handOptionAllProductSildeCartAR(){
  const checCartOption = document.querySelector("#slidecarthq");
  const checkProductOption = document.querySelector("#slidecarthq .slidecarthq .items .item[data-option-status='subcription']");
  const checkSlidecarthq = document.querySelector("#slidecarthq.option__subsave");
  const checkSlidecarthqSub = document.querySelector("#slidecarthq .rewards-progress");
  const checkUpsellTitleCR = document.querySelector("#slidecarthq .custom-money_shipping .title_upsell h2");
  const checkShippingCR = document.querySelector("#slidecarthq .footer .rewards-shipping-text");
  const checkTitleShipping = document.querySelector("#slidecarthq .rewards .rewards-unlock-text p");
  const itemSlideCarts = document.querySelectorAll("#slidecarthq .items");
  if (itemSlideCarts.length) {
   itemSlideCarts.forEach((e, i) => {
     const optionSubcrition = e.querySelector(".item[data-selling-plan='4315775113']");
     const optionSubcrition_2 = e.querySelector(".item[data-selling-plan='4315807881']");

     // Prepaid product 1
     
    if (optionSubcrition) {
      const optionSubcrition_add = e.querySelector(".item[data-selling-plan='4315775113'] .main-medium");
      const optionSubcrition_discount = e.querySelector(".item[data-selling-plan='4315775113'] .main-bottom .price");
      const optionSubcrition_comparePrice = e.querySelector(".item[data-selling-plan='4315775113'] .main-bottom");
      const optionSubcrition_paln = e.querySelector(".item[data-selling-plan='4315775113'] .variants-p");
      const optionSubcrition_paln_val = optionSubcrition_paln.innerHTML;
      const originalString = optionSubcrition_paln_val;
      const stringToRemove = "1 Month,";
      const optionSubcrition_discount_val = optionSubcrition_discount.innerHTML;
      const stToRemove = "$";
      const remove_val = optionSubcrition_discount_val.replace(stToRemove, "");
      const discountedPrice = parseFloat(remove_val);


    // Use the replace function to remove the specified string
      
    var modifiedString = originalString.replace(stringToRemove, "");
      //console.log(modifiedString);
      
        const newDiv = document.createElement("div");
        const Strick_price = document.createElement("span");
        const installemnts = document.createElement("div");
        installemnts.className = 'insatll-month prpaid-class';
       newDiv.className = 'row-ten message-discount';
       Strick_price.className = 'price strike-through custom-strick';
      if(modifiedString == "   3 Months") {
      newDiv.innerHTML = `Subscribe & Save 15% Off!`;
      const discountPercentage = 15;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Quarterly (Every 3 Months)`;
       } 
     if (modifiedString == "   6 Months") {
      newDiv.innerHTML = `Subscribe & Save 20% Off!`;
      const discountPercentage = 20;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Semi-Annually (Every 6 Months)`;
       }
      if (modifiedString == "   12 Months") {
       newDiv.innerHTML = `Subscribe & Save 25% Off!`;
       const discountPercentage = 25;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Annually (Every 12 Months)`;
      }
      
      optionSubcrition_comparePrice.appendChild(Strick_price);

       optionSubcrition_discount.appendChild(newDiv);
        optionSubcrition.classList.add('option__prepaid');
       optionSubcrition_add.innerHTML = `<div class="prpaid-class">One Bottle Delivered Monthly for ${modifiedString}</div>`;
       optionSubcrition_add.appendChild(installemnts);
     }

    // Prepaid product 2

     if (optionSubcrition_2) {
      const optionSubcrition_add = e.querySelector(".item[data-selling-plan='4315807881'] .main-medium");
      const optionSubcrition_discount = e.querySelector(".item[data-selling-plan='4315807881'] .main-bottom .price");
      const optionSubcrition_comparePrice = e.querySelector(".item[data-selling-plan='4315807881'] .main-bottom");
      const optionSubcrition_paln = e.querySelector(".item[data-selling-plan='4315807881'] .variants-p");
      const optionSubcrition_paln_val = optionSubcrition_paln.innerHTML;
      const originalString = optionSubcrition_paln_val;
      const stringToRemove = "1 Month,";
      const optionSubcrition_discount_val = optionSubcrition_discount.innerHTML;
      const stToRemove = "$";
      const remove_val = optionSubcrition_discount_val.replace(stToRemove, "");
      const discountedPrice = parseFloat(remove_val);


    // Use the replace function to remove the specified string
      
    var modifiedString = originalString.replace(stringToRemove, "");
      //console.log(modifiedString);
      
        const newDiv = document.createElement("div");
        const Strick_price = document.createElement("span");
        const installemnts = document.createElement("div");
        installemnts.className = 'insatll-month prpaid-class';
       newDiv.className = 'row-ten message-discount';
       Strick_price.className = 'price strike-through custom-strick';
      if(modifiedString == "   3 Months") {
      newDiv.innerHTML = `Subscribe & Save 15% Off!`;
      const discountPercentage = 15;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Quarterly (Every 3 Months)`;
       } 
     if (modifiedString == "   6 Months") {
      newDiv.innerHTML = `Subscribe & Save 20% Off!`;
      const discountPercentage = 20;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Semi-Annually (Every 6 Months)`;
       }
      if (modifiedString == "   12 Months") {
       newDiv.innerHTML = `Subscribe & Save 25% Off!`;
       const discountPercentage = 25;
      const originalPrice = discountedPrice / (1 - discountPercentage / 100);
      const save_discount_round = Math.round(originalPrice);
      const save_discount_fixed = save_discount_round.toFixed(2);
      Strick_price.innerHTML = "$" + save_discount_fixed;
      installemnts.innerHTML= `Auto Renews Annually (Every 12 Months)`;
      }
      
      optionSubcrition_comparePrice.appendChild(Strick_price);

       optionSubcrition_discount.appendChild(newDiv);
        optionSubcrition_2.classList.add('option__prepaid');
       optionSubcrition_add.innerHTML = `<div class="prpaid-class">One Bottle Delivered Monthly for ${modifiedString}</div>`;
       optionSubcrition_add.appendChild(installemnts);
     }
     
     });
    }
  if(checkProductOption){
    checCartOption.classList.remove('option__onetime');
    checCartOption.classList.add('option__subsave');
    if (checkTitleShipping) {
      checkTitleShipping.innerText = "Your order qualifies for FREE SHIPPING (U.S. Only)!";
    }
    if(checkShippingCR){
      checkShippingCR.innerText = "Taxes Calculated at Checkout.";
    }
    if(checkSlidecarthqSub){
      checkSlidecarthqSub.style.minWidth = "100%";
    }
    if(checkUpsellTitleCR){
      checkUpsellTitleCR.innerText = "You may also like…";
    }
  } else {
    checCartOption.classList.remove('option__subsave');
    checCartOption.classList.add('option__onetime');
    if(checkUpsellTitleCR){
      checkUpsellTitleCR.innerText = "Add product to get FREE SHIPPING";
    }
    if(checkShippingCR){
      checkShippingCR.innerText = "Taxes And Shipping Calculated At Checkout.";
    }
    if(checkSlidecarthqSub){
      checkSlidecarthqSub.style.minWidth = "0%";
    }
    const slideMoney = 120;
    const cehckSlideMoneyTotal = document.querySelector(".slidecart-subtotal");
    if(cehckSlideMoneyTotal){
      const slideMoneyTotal = cehckSlideMoneyTotal.textContent;
      const currencySymbol = "$"; 
      const slideMoneyTotalChange = parseFloat(slideMoneyTotal.replace(currencySymbol, ''));
      if (slideMoneyTotalChange <= slideMoney ){
          const mathslideMoneyTotalChange = slideMoney - slideMoneyTotalChange ;
          if(checkTitleShipping){
            checkTitleShipping.innerText = `Free Shipping (U.S. Only) only $${parseFloat(mathslideMoneyTotalChange).toFixed(2)} Away!`;
          }
          checkUpsellTitleCR.innerText = "Add product to get FREE SHIPPING";
          checkShippingCR.innerText = "Taxes And Shipping Calculated At Checkout.";
          checkSlidecarthqSub.style.minWidth = "0%";
      } else {
        checkTitleShipping.innerText = "Your order qualifies for FREE SHIPPING (U.S. Only)!";
        checkUpsellTitleCR.innerText = "You may also like…";
        checkShippingCR.innerText = "Taxes Calculated at Checkout.";
        checkSlidecarthqSub.style.minWidth = "100%";
      }
    }
  }
}
function handCheckOptionAllProductSildeCart(){
    const itemSlideCarts = document.querySelectorAll("#slidecarthq .items .item");
    if (itemSlideCarts.length) {
      itemSlideCarts.forEach((e, i) => {
        const optionSubcrition = e.querySelector(".rc_widget__option--subsave");
        const optionOnetime = e.querySelector(".rc_widget__option--onetime");
        const cartOptionForm = document.querySelector("#slidecarthq");
        function handleOptionOneTime() {
          if(cartOptionForm.classList.contains('option__subsave')){
            cartOptionForm.classList.remove('option__subsave');
          }
          cartOptionForm.classList.add('option__onetime');
        }
        function handleOptionSub() {
          if(cartOptionForm.classList.contains('option__onetime')){
            cartOptionForm.classList.remove('option__onetime');
          }
          cartOptionForm.classList.add('option__subsave');
        }
        if (optionSubcrition) {
          optionSubcrition.addEventListener("click", handleOptionSub);
        }
        if (optionOnetime) {
          optionOnetime.addEventListener("click", handleOptionOneTime);
        }
      });
    }
}

function handlePriceWhenChangeOptionRC(selectItem, selectPrice) {
  const itemsCardProduct = document.querySelectorAll(selectItem);
  if (itemsCardProduct.length) {
    itemsCardProduct.forEach((e, i) => {
      const optionSubcrition = e.querySelector("[data-radio-subsave]");
      const optionOnetime = e.querySelector("[data-radio-onetime]");

      if (optionSubcrition && optionOnetime) {
        optionSubcrition.onchange = function () {
          let price = this.form;
          let percent = 10;

          if (price.getAttribute("subcription") == "5%") {
            percent = 5;
          }

          price = price.querySelectorAll(selectPrice);

          price.forEach((e) => {
            let valuePrice = e.innerText;
            valuePrice = valuePrice.substring(1);
            let discount = (Number(valuePrice) / 100) * percent;
            let priceDiscount = Number(valuePrice) - discount;
            priceDiscount = priceDiscount.toFixed(2);
            let oneTimeValue = e.getAttribute('data-one-time');
            if(oneTimeValue == "$74.95"){
              e.innerText = `$67.46`;
             }
            else{
              e.innerText = `$${priceDiscount}`;
            }
            
            e.style.color = "#bd472a";
          });
        };

        optionOnetime.onchange = function () {
          let price = this.form;
          let percent = 10;

          if (price.getAttribute("subcription") == "5%") {
            percent = 5;
          }

          price = price.querySelectorAll(selectPrice);

          price.forEach((e) => {
            let valuePrice = e.innerText;
            let oneTimeValue = e.getAttribute('data-one-time');
            //alert(oneTimeValue);
            valuePrice = Number(valuePrice.substring(1));
            let discount = valuePrice / (100 - percent);
            discount = discount * percent;
            let priceDiscount = valuePrice + discount;
            priceDiscount = priceDiscount.toFixed(2);
            e.innerText = `${oneTimeValue}`;
            e.style.color = "#1f0a00";
          });
        };
      }
    });
  }
}

async function ancestralApplyWidgetRechargeCartTray(cart) {
  loadingCart();
  addNodeParentRC(cart.items);

  await sleepInCartTray(500);
  let items = document.querySelectorAll(
    "#slidecarthq .slidecarthq .items .item"
  );
  
  items = Array.prototype.slice.call(items);

  items.forEach((e) => e.classList.remove("loaded"));

  const config = items.map((e) => {
    return {
      productId: Number(e.dataset.productid),
      injectionParent: `.rc-widget-injection-parent-cart-tray-${e.dataset.productid}-${e.dataset.sellingPlan}`,
      injectionMethod: "prepend",
      selectors: {
        price: [".none"],
        variant: [".none"],
      },
    };
  });

  const addTextMostPopular = () => {
    let optionFirst = document.querySelectorAll(
      "#slidecarthq select.rc-selling-plans__dropdown option:first-child"
    );

    optionFirst.forEach((e) => {
      let text = e.innerText;
      let hasAdd = text.includes("Most popular") ? true : false;
      if (hasAdd === true) return;
      text = `${text} (Most popular)`;
      e.innerText = text;
    });
  };

  addOtpIn();

  window.ReChargeWidget.createWidgets(config);

  await sleepInCartTray(1000);
  addTextMostPopular();
  addPrefixForInputAndLabelCartTray();
  handleSelectorOptionRCinCartTray();
  await sleepInCartTray(1000);
  replaceRecentCorrectInTooltip(".item[data-persent]", "data-persent");
}

function addPrefixForInputAndLabelCartTray() {
  const itemCart = document.querySelectorAll(
    "#slidecarthq .slidecarthq .items .item"
  );
  itemCart.forEach((e) => {
    const sellingPlan = e.dataset.sellingPlan;
    const listInputs = e.querySelectorAll("input.rc-radio__input");
    const listLabels = e.querySelectorAll("label.rc-radio__label");
    if (listInputs.length && listLabels.length) {
      listInputs.forEach((input) => {
        let idInput = input.getAttribute("id");
        let nameInput = input.getAttribute("name");
        idInput = `cart_tray_${idInput}_${sellingPlan}`;
        nameInput = `cart_tray_${nameInput}_${sellingPlan}`;
        input.setAttribute("id", idInput);
        input.setAttribute("name", nameInput);
      });

      listLabels.forEach((label) => {
        let forLabel = label.getAttribute("for");
        forLabel = `cart_tray_${forLabel}_${sellingPlan}`;
        label.setAttribute("for", forLabel);
      });
    }

    const dataPersent = e.dataset.persent;
    const labelSubcription = e.querySelector(
      "[data-label-subsave] [data-label-discount]"
    );

    if (dataPersent && labelSubcription) {
      labelSubcription.setAttribute("data-persent", dataPersent);
    }
  });
}

function ancestralGetDataProductCart(items) {
  const result = items.map((e) => {
    return {
      idProduct: e.product_id,
      idSellingPlan: e.selling_plan_allocation?.selling_plan.id,
      priceOrigin:
        Number(e.selling_plan_allocation?.compare_at_price) *
        Number(e.quantity),
      persent: e.properties?._subcription_percent,
    };
  });

  return result;
}

async function addNodeParentRC(items) {
  const listItem = document.querySelectorAll(
    "#slidecarthq .slidecarthq .items .item"
  );
  const data = ancestralGetDataProductCart(items);

  listItem.forEach((item, i) => {
    const classParentWidgetRC = `rc-widget-injection-parent-cart-tray-${data[i].idProduct}-${data[i].idSellingPlan}`;

    const hasMainMedium = item.querySelector(".main-medium");
    item.setAttribute("data-productid", `${data[i].idProduct}`);
    item.setAttribute("data-selling-plan", `${data[i].idSellingPlan}`);
    item.setAttribute(
      "data-option-status",
      `${data[i].idSellingPlan ? "subcription" : "onetime"}`
    );
    item.setAttribute(
      "data-price-origin",
      `${data[i].priceOrigin ? data[i].priceOrigin : ""}`
    );

    if (data[i].persent) {
      item.setAttribute("data-persent", data[i].persent);
    }

    let nodeParentWidgetRC = document.createElement("div");
    nodeParentWidgetRC.classList.add(classParentWidgetRC);

    if (hasMainMedium) {
      hasMainMedium.innerHTML = "";
      hasMainMedium.appendChild(nodeParentWidgetRC);
    } else {
      let mainMedium = document.createElement("div");
      mainMedium.classList.add("main-medium");
      mainMedium.appendChild(nodeParentWidgetRC);
      item
        .querySelector(".main")
        .insertBefore(mainMedium, item.querySelector(".main").children[1]);
    }
  });
}

function handleSelectorOptionRCinCartTray() {
  const itemCart = document.querySelectorAll("#slidecarthq .item");

  itemCart.forEach((e, i) => {
    const idVariant = e.dataset.variantId,
      optionStatus = e.dataset.optionStatus,
      sellingPlanId = e.dataset.sellingPlan,
      persent = e.dataset.persent,
      priceOrigin = Number(e.dataset.priceOrigin) / 100,
      line = i + 1,
      btnOnetime = e.querySelector(
        "[data-selector-onetime] label.rc-radio__label"
      ),
      inputOnetime = e.querySelector(
        "[data-selector-onetime] input.rc-radio__input"
      ),
      btnSubcription = e.querySelector(
        "[data-selector-subsave] label.rc-radio__label"
      ),
      inputSubcription = e.querySelector(
        "[data-selector-subsave] input.rc-radio__input"
      ),
      subcriptionWrap = e.querySelector("[data-option-subsave]"),
      sellingPlan = e.querySelector("[data-option-subsave] .rc-selling-plans"),
      sellingOption = e.querySelector(
        "[data-option-subsave] select[data-plans-dropdown]"
      );

    const hasMessage = e.querySelector(".message-discount");
    const hasPriceOrigin = e.querySelector(".price.strike-through");
    const rowBottom = e.querySelector(".main-bottom");

    let mesSubcrition = document.createElement("div");
    mesSubcrition.classList.add("message-discount");
    let priceOriginNode = document.createElement("span");
    priceOriginNode.classList.add("price");
    priceOriginNode.classList.add("strike-through");
    priceOriginNode.innerText = `$${priceOrigin.toFixed(2)}`;

     /* start cart drawer percent discount daynamic changes */
  
    if(optionStatus == "subcription"){
    setTimeout(function() {
    const percentage = e.querySelector(".main-medium span.rc-option__discount.rc_widget__option__discount");
    const discount_percentage = percentage.innerHTML;
       if (discount_percentage) {
      mesSubcrition.innerText = `Subscribe & Save ${discount_percentage} Off!`;
    } 
      const contentTooltip = e.querySelector(".rc_popup__how_it_works p");
    if (contentTooltip) {
     contentTooltip.innerText = `Save an additional ${discount_percentage} and FREE shipping on all US subscriptions. Change or cancel anytime.`;
    }
      }, 2000);
    }

     /* End start cart drawer percent discount daynamic changes */

    if (persent) {
      mesSubcrition.innerText = `Subscribe & Save ${persent}% Off!`;
    } else {
      mesSubcrition.innerText = "Subscribe & Save 10% Off!";
    }

    if (inputSubcription && inputOnetime) {
      if (optionStatus == "subcription") {
        inputSubcription.checked = true;
        inputOnetime.checked = false;
        sellingOption.value = sellingPlanId;
        subcriptionWrap.classList.add("rc-option--active");
        sellingPlan.style.display = "block";
        hasMessage == null && rowBottom.appendChild(mesSubcrition);
        hasPriceOrigin == null && rowBottom.prepend(priceOriginNode);
      } else if (optionStatus == "onetime") {
        inputSubcription.checked = false;
        inputOnetime.checked = true;
        subcriptionWrap.classList.remove("rc-option--active");
        sellingPlan.style.display = "none";
        hasMessage != null && hasMessage.remove();
        hasPriceOrigin != null && hasPriceOrigin.remove();
      }
    }

    e.classList.add("loaded");

    if (btnOnetime) {
      btnOnetime.onclick = function (event) {
        event.preventDefault();
        disableSelectCartTray();
        this.previousElementSibling.checked = true;
        btnSubcription.previousElementSibling.checked = false;
        subcriptionWrap.classList.remove("rc-option--active");
        sellingPlan.style.display = "none";
        const qtyCurrent = e.querySelector(
          ".quantity-selector input[type=text]"
        ).value;
        handleChangeOptionRCinCartTray(
          { id: Number(idVariant), quantity: Number(qtyCurrent) },
          line
        );
      };
    }

    if (btnSubcription) {
      btnSubcription.onclick = function (event) {
        event.preventDefault();
        disableSelectCartTray();
        const sellingOptionDefault = e
          .querySelector(
            "[data-option-subsave] select[data-plans-dropdown] option:first-child"
          )
          .getAttribute("value");
        this.previousElementSibling.checked = true;
        btnOnetime.previousElementSibling.checked = false;
        subcriptionWrap.classList.add("rc-option--active");
        sellingPlan.style.display = "block";
        const qtyCurrent = e.querySelector(
          ".quantity-selector input[type=text]"
        ).value;
        handleChangeOptionRCinCartTray(
          {
            id: Number(idVariant),
            selling_plan: Number(sellingOptionDefault),
            quantity: Number(qtyCurrent),
          },
          line
        );
      };
    }

    if (sellingOption) {
      sellingOption.onchange = function (event) {
        disableSelectCartTray();
        const qtyCurrent = e.querySelector(
          ".quantity-selector input[type=text]"
        ).value;
        handleChangeOptionRCinCartTray(
          {
            id: Number(idVariant),
            selling_plan: Number(this.value),
            quantity: Number(qtyCurrent),
          },
          line
        );
      };
    }
    
    const parentElement = document.querySelector('#slidecarthq .slidecarthq');
    if(parentElement){
      var parentHeight = parentElement.scrollHeight;
      const childCart = document.querySelector('.custom-bg-event-cartTray');
      if(childCart){
        childCart.style.height = parentHeight + 'px'; ;
      }
    }
    const sliderCartLoad = document.querySelector('#slidecarthq');
    if(sliderCartLoad){
      setTimeout(() => {
      sliderCartLoad.classList.remove('active');
      }, 500);
    }
  });
}

async function removeItemCartInByKeyCartTray(line) {
  const data = {
    line: line,
  };

  const result = await fetch("/cart/change.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      ...data,
      quantity: 0,
    }),
  });

  return result.json();
}

async function addItemCartInCartTray(data) {
  const result = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  });

  return result.json();
}

async function handleChangeOptionRCinCartTray(config, line) {
  loadingCart();
  const itemCarts = document.querySelectorAll("#slidecarthq .items .item");
  const persent = itemCarts[line - 1].dataset.persent;

  handCheckOptionAllProductSildeCart();
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get("utm_source");

  if (persent) {
    config = {
      ...config,
      properties: {
        subcription_percent: persent,
      },
    };
  }

  config = {
    ...config,
    properties: {
      ...config.properties,
      utm_source: utmSource,
    },
  };

  const data = {
    items: [config],
  };

  await removeItemCartInByKeyCartTray(line);
  await addItemCartInCartTray(data);
  // await sleepInCartTray(500);
  window.SLIDECART_UPDATE();
}

function disableSelectCartTray() {
  let labelSelects = document.querySelectorAll(
    "#slidecarthq .items .item label"
  );
  labelSelects.forEach((e) => {
    e.style.pointerEvents = "none";
  });
}

function removeDisableSelectCartTray() {
  let labelSelects = document.querySelectorAll(
    "#slidecarthq .items .item label"
  );
  labelSelects.forEach((e) => {
    e.style.pointerEvents = "";
  });
}

function replaceRecentCorrectInTooltip(
  selectItem = "form[subcription]",
  attrPecent = "subcription"
) {
  const items = document.querySelectorAll(selectItem);

  if (items.length) {
    items.forEach((e) => {
      let percent = e.getAttribute(attrPecent);
      if (!percent.includes("%")) {
        percent = `${percent}%`;
      }

      let contentTooltip = e.querySelector(".rc_popup__how_it_works p");
      if (contentTooltip) {
        contentTooltip = contentTooltip.innerText;
        contentTooltip = contentTooltip.replace("10%", percent);
        e.querySelector(".rc_popup__how_it_works p").innerText = contentTooltip;
      }
    });
  }
}

function replaceBundleProductTooltip() {
  let forms = document.querySelectorAll('form[data-productid="7224812667017"],form[data-productid="7044086464649"],form[data-productid="7271083442313"]');
  console.log(forms)
  forms.forEach((e) => {
    let contentTooltip = e.querySelector(".rc_popup__how_it_works p");
    if (contentTooltip) {
      console.log('in')
      contentTooltip.innerText = 'Save an additional 5% and FREE shipping on all US subscriptions. Change or cancel anytime.';
    }
  });
}

function addOtpIn() {
  const cartSmsParent = document.getElementById("rcsms-cart-widget-parent");
  const cartSmsChild = document.getElementById("rcsms-cart-widget");

  const cartTrayOption = document.querySelector(
    ".rc_widget__option--subsave.rc_widget__option--active"
  );
  if (cartTrayOption && cartSmsChild && cartSmsParent) {
    cartSmsParent.appendChild(cartSmsChild);
  } else if (cartSmsChild) {
    cartSmsChild.style.display = "none";
  }
}

function checkGiftCardInCart(cart) {
  const hasProductDiscount = cart.items.some((e) => e.id === 40971854610569);
  const hasGiftCard = cart.items.some((e) => e.id === 40999138689161);

  if (
    (!hasProductDiscount && !hasGiftCard) ||
    (hasProductDiscount && hasGiftCard)
  ) {
    return true;
  }

  let lineItemGiftCard;
  cart.items.forEach((e, i) => {
    if (e.id == 40999138689161) {
      lineItemGiftCard = i + 1;
    }
  });

  const addGiftCard = () => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        quantity: 1,
        id: 40999138689161,
      }),
    }).then((res) => {
      window.SLIDECART_UPDATE();
    });
  };

  const removeGiftCard = (line) => {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        line: 1,
        quantity: 0,
      }),
    }).then((res) => {
      window.SLIDECART_UPDATE();
    });
  };

  if (
    window.location.pathname.includes("/cart") ||
    window.location.pathname.includes("/products")
  ) {
    if (hasProductDiscount && !hasGiftCard) {
      window.SLIDECART_UPDATE();
      return false;
    }

    if (hasGiftCard && !hasProductDiscount) {
      window.SLIDECART_UPDATE();
      return false;
    }
  }

  if (window.location.pathname == "/collections/shop") {
    if (hasProductDiscount && !hasGiftCard) {
      addGiftCard();
    }
    if (hasGiftCard && !hasProductDiscount && lineItemGiftCard) {
      removeGiftCard(lineItemGiftCard);
    }
  }
}

const applyCountCart = (cart) => {
  const cartCount = document.getElementById("CartCount");
  if (cartCount) {
    cartCount.innerHTML = `<span>${cart.item_count}</span>`;
  }
};

if (typeof Shopify === "undefined") {
  window.Shopify = {};
}
if (typeof Shopify.getCart === "undefined") {
  Shopify.getCart = function (callback, cart) {
    if (!cart) {
      return jQuery.getJSON("/cart.js", function (cart, textStatus, xhr) {
        if (typeof callback === "function") {
          callback(cart, textStatus, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if (typeof callback === "function") {
        callback(cart);
      } else if (typeof Shopify.onCartUpdate === "function") {
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

window.SLIDECART_UPDATED = function (cart) {
  loadingCart();
  
  if (typeof SECOMAPP === "undefined") {
    SECOMAPP = {};
  }

  SECOMAPP.preShowPopup = function () {
    window.SLIDECART_CLOSE();
  };

  Shopify.getCart(function (newcart) {
    if (
      newcart.item_count !== cart.item_count ||
      newcart.total_price !== cart.total_price ||
      newcart.token !== cart.token ||
      newcart.items.length !== cart.items.length
    ) {
      window.SLIDECART_CLOSE();
      window.SLIDECART_UPDATE(newcart);
      window.SLIDECART_OPEN();
    }
  }, cart);

  // const handleGiftCart = checkGiftCardInCart(cart)
  // if (handleGiftCart == false) {
  //   return;
  // }
  ancestralApplyWidgetRechargeCartTray(cart);
  handOptionAllProductSildeCartAR();
  applyCountCart(cart);
};
function loadingCart() {
  const sliderCartLoad = document.querySelector('#slidecarthq');
  if(!sliderCartLoad.classList.contains('active')){
    sliderCartLoad.classList.add('active');
  }
}
window.SLIDECART_OPENED = function() {
  handOptionAllProductSildeCartAR();
}
window.SLIDECART_UPSELL_ADD = function(id) {
  loadingCart();
}